export default {
  methods: {
    handlePress (el, callback) {
      if (!el) {
        return
      }
      let _startX, _startY, isDidCallBack
      el.addEventListener('touchstart', (e) => {
        // e.preventDefault()
        _startX = e.changedTouches[0].pageX
        _startY = e.changedTouches[0].pageY
      })

      el.addEventListener('touchmove', (e) => {
        // e.preventDefault()
        const moveEndX = e.changedTouches[0].pageX
        const moveEndY = e.changedTouches[0].pageY
        const left = moveEndX - _startX < 0
        const top = moveEndY - _startY < 0

        if (!isDidCallBack) {
          callback(left, top)
          isDidCallBack = true
        }
      })

      el.addEventListener('touchend', (e) => {
        // e.preventDefault()
        isDidCallBack = false
      })
    }
  }
}
